import { useDispatch, useSelector } from "react-redux";
import { RdxType, StringObjectDictionary } from "../data/Types";
import { PlantObjectExtended, CHANGE_PLANTDATA, CHANGE_SELECTED_PLANTS, CHANGE_PLANTGROUPS } from "../data/redux/plantReducer";
import { useFetch } from "./data/useFetcher";
import { DataHelper } from "../data/Helpers";
import { CHANGE_UI_PLANTSEARCH, PlantSearchUITarget, PlantSearchUITargetType, PlantSearchUIType } from "../data/redux/uIReducer";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Config } from "../data/Config";
import { useDialogs } from "../../components/ui/Simple/MesssageBoxes";
import { useAdsUISettings } from "../../components/ui/Simple/Ads/useAds";
import { useAssortmentsData, useSimpleAssortments } from "../../components/ui/Simple/Assortments/useSimpleAssortments";
import { useOrganization } from "./entities/useOrganization";
import { useNavigateToElement } from "./ui/useUIHelper";
import { ELEMENT_PLANTSSECTION_ID } from "../../components/ui/Simple/SimpleAssortments";
import { useTranslation } from "react-i18next";

// Search operations
export const usePlantSearch = () => {

    const data = usePlantReducer();
    const api = usePlantSearchApi();
    const plant = usePlantUI();

    const [searching, setSearching] = useState<boolean>(false);
    const [searchMetaData, setSearchMetaData] = useState<SearchHitMetaDataType | undefined>(undefined)
    const [searchResultIds, setSearchResultIds] = useState<string[]>();
    const [lastSearch, setLastSearch] = useState<FilterSearchType | undefined>(undefined);
    const [responseSet, setResponseSet] = useState<{ [x: number]: SearchHitType }>({})

    const _search = async (f: FilterSearchType, forceSearch?: boolean) => {
        setSearching(true);
        setLastSearch(f);

        const responseExists = !!responseSet?.[f?.pageIndex] && forceSearch !== true;
        const response: SearchHitType = responseExists ? responseSet[f.pageIndex] : await api.search(f);

        // Add to db:
        const { hits, ...meta } = response;
        setSearchMetaData(meta);
        data.addplantsToDb(response?.hits);
        setSearchResultIds(response?.hits?.map(m => m?.id));
        setSearching(false);
        return response;
    }

    const search = async (e: string) => {
        const f: FilterSearchType = {
            search: e,
            pageSize: searchDefaultPageSize,
            pageIndex: 0
        };
        const response = await _search(f, true);
        setResponseSet({ 0: response });
    }

    const searchNewPage = async (pageIndex: number) => {
        const f: FilterSearchType = {
            search: lastSearch?.search ?? "",
            pageSize: lastSearch?.pageSize ?? searchDefaultPageSize,
            pageIndex: pageIndex
        };
        const response = await _search(f);
        setResponseSet({ ...responseSet, [f.pageIndex ?? 0]: response });
    }

    const pr = usePlantReducer();
    useEffect(() => {
        pr.loadProps();
    }, []);

    return {
        getPlant: plant.getPlant,
        dbCount: data.dbCount,
        selected: data.selected,
        selectedCount: data.selectedCount,

        onSearch: search,
        onSearchNewPage: searchNewPage,

        searching: searching,
        searchMetaData: searchMetaData,
        searchResultIds: searchResultIds,

    }
}

// DB + UI
export const usePlantUI = () => {
    const dispatch = useDispatch();
    const nav = useNavigate();
    const { t } = useTranslation();
    const db = useSelector((state: RdxType) => state.plants.db);
    const plantSearchUI = useSelector((state: RdxType) => state.ui.plantSearchUI);
    const plantReducer = usePlantReducer();
    const dialogs = useDialogs();
    const adsUI = useAdsUISettings();
    const assortments = useAssortmentsData();
    const org = useOrganization();
    const scroll = useNavigateToElement();

    const [plantChanges, setPlantChanges] = useState<StringObjectDictionary<number>>({});


    return {
        db: db,
        getPlant: (plantId: string) => {
            return db?.[plantId];
        },
        ui: plantSearchUI.planttarget,
        gotoAdPlantsToTarget: (options: PlantSearchUITarget) => {
            if (options?.type === "assortment") {
                const d: PlantSearchUIType = { ...plantSearchUI, planttarget: options }
                dispatch({ type: CHANGE_UI_PLANTSEARCH, payload: d });
                plantReducer.setSelected(DataHelper.arrayToStringStringObject(options.plantCart))
                nav(Config.routes.simple_assortment_edit)
            } else if (options?.type === "ad") {
                const d: PlantSearchUIType = { ...plantSearchUI, planttarget: options }
                dispatch({ type: CHANGE_UI_PLANTSEARCH, payload: d });
                plantReducer.setSelected(DataHelper.arrayToStringStringObject(options.plantCart))
                nav(Config.routes.simple_ads_plant)
            } else if (options?.type === "none") {
                const d: PlantSearchUIType = { ...plantSearchUI, planttarget: options }
                dispatch({ type: CHANGE_UI_PLANTSEARCH, payload: d });
                nav(Config.routes.simple_assortment_edit)
            } else {
                const d: PlantSearchUIType = { ...plantSearchUI, planttarget: options }
                dispatch({ type: CHANGE_UI_PLANTSEARCH, payload: d })
            }
        },

        toggleSelected: (e: string) => {
            const adding = !plantReducer.selected?.[e];


            if (!plantChanges[e]) {
                const plantChanges_new = { ...plantChanges, [e]: adding ? 1 : -1 };
                setPlantChanges(plantChanges_new);
                console.log("plantChanges_new:", plantChanges_new);
            } else {
                let plantChanges_new = { ...plantChanges, [e]: plantChanges[e] + (adding ? 1 : -1) };
                if (plantChanges_new[e] === 0) {
                    delete plantChanges_new[e];
                }
                setPlantChanges(plantChanges_new);
                console.log("plantChanges_new:", plantChanges_new);
            }

            const _cartMaxSize: number = plantSearchUI?.planttarget?.cartMaxSize ?? 0;
            if (_cartMaxSize > 0) {
                const count = Object.keys(plantReducer.selected ?? {}).length;
                console.log("plantReducer.selected:", plantReducer.selected);
                if (adding && count >= _cartMaxSize) {
                    dialogs.showWarning(
                        "Max 10 växter",
                        "Du kan inte lägga till fler än " + _cartMaxSize + " växter.")
                    return;
                }
            }
            plantReducer.toggleSelected(e, adding);
        },

        toggleAll: () => {
            let r: StringObjectDictionary<string> = {};
            // if (Object.keys(plantReducer.selected ?? {}).length == 0) {
            //     searchResultIds?.forEach((id: string) => r[id] = id);
            // }
            plantReducer.setSelected(r);
        },
        confirmCartClick: async () => {


            const added = Object.keys(plantChanges).map(key => plantChanges[key]).filter(m => m === 1).length;
            const removed = Object.keys(plantChanges).map(key => plantChanges[key]).filter(m => m === -1).length;

            if (added > 0 && removed > 0) {
                dialogs.showToast(t("XPlantsAddedAndYRemoved", { added: added, removed: removed }));
            } else if (added > 0) {
                dialogs.showToast(t("XPlantsAdded", { count: added }));
            } else if (removed > 0) {
                dialogs.showToast(t("XPlantsRemoved", { count: removed }));
            } else {
                dialogs.showToast(t("noActionWasTaken"));
            }
            // X växter tillagda och Y borttagna.
            // X växter tillagda.
            // X växter borttagna.



            console.log("plantSearchUI:", plantSearchUI);
            if (plantSearchUI.planttarget?.type === "ad") {
                const sel = Object.keys({ ...plantReducer.selected });
                adsUI.updateAdPlantIds(plantSearchUI.planttarget?.id ?? "", sel)
                nav(-1);
            }
            if (plantSearchUI.planttarget?.type === "assortment") {
                const selected = Object.keys({ ...plantReducer.selected });
                await assortments.setPlantAssortment(org.currentOrganization?.id ?? "", selected);
                nav(-1);
                scroll.setNavigateToElementId(ELEMENT_PLANTSSECTION_ID);
            }
        }
    }
}

// Plant Data for single plant
export const usePlant = (plantId: string) => {
    const db = useSelector((state: RdxType) => state.plants.db);
    return { ...db?.[plantId] }
}

// Plant Data operations
export const usePlantReducer = () => {
    const f = useFetch();
    const db = useSelector((state: RdxType) => state.plants.db);
    const selectedPlants = useSelector((state: RdxType) => state.plants.selectedPlants);
    const plantGroups = useSelector((state: RdxType) => state.plants.plantGroups);
    const dispatch = useDispatch();
    const api = usePlantSearchApi();

    const loadProps = async () => {
        // api/plants/fields
        const data: PlantFieldType[] = await f.get("/api/plants/fields");

        const grp = data?.find(m => m?.id == "GRUPPERING");
        if (!!grp) {
            let pg: any = {};
            grp.selectOptions?.forEach(so => pg[so?.key] = so?.name)
            dispatch({ type: CHANGE_PLANTGROUPS, payload: pg });
        }
    }

    const addplantsToDb = (e: PlantObjectExtended[]) => {
        let _new: StringObjectDictionary<PlantObjectExtended> = {};
        e?.forEach(n => {
            _new[n.id] = transformPlant({ ...n });
        });
        dispatch({ type: CHANGE_PLANTDATA, payload: _new })
    }

    // Parses json properties from elastic plant
    const transformPlant = (n: PlantObjectExtended) => {
        let _n = { ...n };
        // Gruppering
        _n.gruppering = DataHelper.getAnyAsArray(_n?.gruppering)
        _n.grupperingText = plantGroups?.[_n.gruppering?.[0]];

        return _n;
    }

    const loadPlantIds = async (e: string[]) => {
        if (Array.isArray(e)) {
            const lst = e?.filter(m => !db?.[m])?.filter(m => !!m);
            if (lst?.length > 0) {
                const response: SearchHitType = await api.loadIds(lst);
                const { hits, ...meta } = response;
                addplantsToDb(hits);
            }
        }
    }

    return {
        // DB
        db: db,
        dbCount: Object.keys(db ?? {}).length,
        addplantsToDb: addplantsToDb,
        loadPlantIds: loadPlantIds,

        // Load...
        loadProps: loadProps,

        // Selected
        selected: selectedPlants,
        setSelected: (e: StringObjectDictionary<string> | undefined) => {
            dispatch({ type: CHANGE_SELECTED_PLANTS, payload: e });
        },
        selectedCount: Object.keys(selectedPlants ?? {}).length,
        toggleSelected: (id: string, adding: boolean) => {
            let _selected = { ...selectedPlants };
            if (adding === true) {
                _selected[id] = id;
            } else {
                if (!!_selected?.[id]) {
                    delete _selected[id];
                }
            }
            Object.keys(_selected).forEach(key => {
                if ((key?.length ?? 0) < 5) {
                    delete _selected[key]
                }
            })
            dispatch({ type: CHANGE_SELECTED_PLANTS, payload: _selected });
        },
    }
}

// Typed api Requests
export const usePlantSearchApi = () => {
    const f = useFetch();

    const search = async (e: FilterSearchType): Promise<SearchHitType> => {
        const p = {
            search: e?.search ?? "",
            pageIndex: e?.pageIndex ?? 0,
            pageSize: e?.pageSize ?? searchDefaultPageSize,
            sorting: "elastic",
            keepJson: true
        };
        const response: SearchHitType = await f.post("/api/plant/filter", p);
        return response;
    }

    const loadIds = async (e: string[]): Promise<SearchHitType> => {
        const response: SearchHitType = await f.post("/api/plant/getmultiple/main/json", e);
        return response;
    }

    return {
        search: search,
        loadIds: loadIds
    }
}

// ############################# Constants #############################
export const searchDefaultPageSize = 10;

// ##################################### Plant Search Filter Api #####################################
export type FilterSearchType = {
    search: string,
    pageIndex: number,
    pageSize: number
}

// ##################################### Filter Response #####################################
export type SearchHitMetaDataType = {
    totalHitsCount: number
    pageHitCount: number
    took: number
    pageIndex: number
    pagesize: number
    suggestions: string[]
}

export type SearchHitType = SearchHitMetaDataType & {
    hits: PlantObjectExtended[]
}



export type PlantFieldType = {
    name: string
    description: string
    plantTypeCategoryKey: string
    plantTypeCategoryDescription: string
    public: boolean
    sortOrder: number
    suffix?: string
    type: number
    typeString: string
    selectOptions: SelectOption[]
    id: string
    imageid: string
    sys_datecreated_utc_epoch: number
}

export interface SelectOption {
    key: string
    name: string
    default: boolean
    data?: string
    selectable: boolean
}
